import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { resourceQueryPredicates } from '../../resources/queries/resourceQueryPredicates.js';
import { useQueryCacheResourceHelpers } from '../../resources/utils/useQueryCacheResourceHelpers.js';
import { handleUpload } from '../../upload/utils/handleUpload.js';
import { useWoody } from '../../woody/woody.js';
import { UploadTaskPriority } from '@fabric-app/types/upload';
import { useQueryClient, useMutation } from '@tanstack/react-query';

const useMutationResourceCoverUpdate = () => {
  const { client } = useWoody();
  const accessToken = useContextAccessToken();
  const queryClient = useQueryClient();
  const { updateCachedResource } = useQueryCacheResourceHelpers();
  const mutation = useMutation({
    mutationKey: [
      "resource-cover-update"
    ],
    mutationFn: async ({ resource, cover }) => {
      await client.v2({
        endpoint: "/v2/resources/{resourceId}",
        params: {
          resourceId: resource.id
        }
      }, {
        method: "patch",
        body: {
          coverStoragePath: cover ? (await handleUpload({
            bucket: "stored-files",
            data: {
              type: "file",
              file: cover,
              available: true
            },
            priority: UploadTaskPriority.Instant
          })).key : null
        },
        query: {
          accessToken
        }
      });
    },
    onMutate: async ({ resource, cover }) => {
      const tmpCoverUrl = cover ? URL.createObjectURL(cover) || null : null;
      updateCachedResource({
        id: resource.id,
        cover: tmpCoverUrl ? {
          url: tmpCoverUrl,
          width: cover?.size,
          height: cover?.size,
          mime: cover?.type
        } : null
      });
    },
    /**
    * can't do optimistic update here because BE needs to setup the cover object first
    * so we refetch (invalidate) the resource detail query
    */
    onSettled: (d, e, { resource }) => {
      queryClient.invalidateQueries({
        predicate: (query) => resourceQueryPredicates.resourceDetail(query, resource.id)
      });
    }
  });
  return mutation;
};

export { useMutationResourceCoverUpdate };
//# sourceMappingURL=useMutationResourceCoverUpdate.js.map
